import React from 'react';
import type { FCWithChildren } from '../../../../types/FCWithChildren';

export const SectionName: FCWithChildren = ({ children }) => {
  return (
    <section className="w-32">
      <span className="text-sm font-medium not-italic leading-5 text-gray-600">{children}</span>
    </section>
  );
};
